@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.trainingprogram

import kotlin.uuid.Uuid

class TrainingProgramService(private val api: TrainingProgramApi) {
    suspend fun createTrainingProgram(
        selectedGoals: Set<MainGoal>,
        selectedLevel: LevelKey,
        selectedAgeGroup: AgeGroupKey,
        weekdays: List<WeekdayState>,
    ) {
        val schedule = weekdays
            .filter { it.isChecked && it.selectedDuration != null }
            .map { DayAndDuration(it.weekday, it.selectedDuration!!) }

        val trainingProgram = CreateTrainingProgramRequest(
            goals = selectedGoals,
            level = selectedLevel,
            ageGroup = selectedAgeGroup,
            schedule = schedule
        )
        api.createTrainingProgram(trainingProgram)
    }

    suspend fun createTrainingProgramBasedOnPrevious() {
        api.createTrainingProgramBasedOnPrevious()
    }

    suspend fun updateTrainingProgram(
        trainingProgramGuid: Uuid,
        selectedGoals: Set<MainGoal>,
        selectedLevel: LevelKey,
        selectedAgeGroup: AgeGroupKey,
        schedule: List<DayAndDuration>,
    ) {
        api.updateTrainingProgram(
            UpdateTrainingProgramRequest(
                trainingProgramGuid = trainingProgramGuid,
                goals = selectedGoals,
                level = selectedLevel,
                ageGroup = selectedAgeGroup,
                schedule = schedule
            )
        )
    }
}
